import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { format, subDays } from "date-fns";

import { PriceRemarkFilterState } from "./types";

function initialFilters(): PriceRemarkFilterState["filters"] {
  const today = new Date();
  return {
    dtIni: format(subDays(today, 7), "yyyy-MM-dd"),
    dtFim: format(today, "yyyy-MM-dd"),
    loja: null,
    tipo: null,
    status: null,
    confere: null,
    vigencia: null,
    page: 1,
    perPage: 20,
    sortBy: null,
    sortOrder: null,
  };
}

const INITIAL_STATE: PriceRemarkFilterState = { filters: initialFilters() };

const priceRemarkFilterSlice = createSlice({
  name: "priceRemarkFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(
      state,
      action: PayloadAction<{ key: string; value: unknown }>,
    ) {
      (state.filters as Record<string, unknown>)[action.payload.key] =
        action.payload.value;
    },
    resetFilters(state) {
      state.filters = initialFilters();
    },
  },
});

export const { setFilter, resetFilters } = priceRemarkFilterSlice.actions;
export default priceRemarkFilterSlice.reducer;
